import React, { Component } from 'react';
import Arrow from '../assets/icons/drop.svg';
import Ng from '../assets/svg/nig.svg';
import Gh from '../assets/svg/icons-new/ghana.png'

import './css/pc.css';


export default class pickCountryNumberAirtime extends Component {

    state = {
        allCountries: [],
        countryChoice: "Nigeria",
        countryCode: this.props.defaultCode ?? "+234"
    }

    async componentDidMount() {
        const selected = document.querySelector(".pc-selected4")
        const optionsContainer = document.querySelector(".pc-options-container4")
        const optionsList = document.querySelectorAll(".pc-option4");

        localStorage.setItem("countryCodeA", "+234")

        selected.addEventListener("click", () => {
            optionsContainer.classList.toggle("active");
        })

        await optionsList.forEach(opt => {
            opt.addEventListener("click", async () => {
                selected.innerHTML = opt.querySelector("label").innerHTML;
                //opt.querySelector("input").checked = true; //line that selects the radio button when the div is clicked
                await optionsContainer.classList.remove("active");
                const optn = opt.querySelector("span").innerHTML;
                console.log(optn)
                localStorage.setItem("countryCodeA", optn)
                //if(this.props.handleCountryPicker) this.props.handleCountryPicker(optn.substr(3))
                //console.log(localStorage.getItem("countryCode"))
            });
        });

    }

    render() {

        return (

            <div className="pc3-section">
                <div className="pc-box4">
                    <div className="pc-options-container4">
                            <div className="pc-option4" 
                            >
                                <input type="radio"
                                       className="radio"
                                       id="country"
                                       name="country"
                                       value="+234"
                                />
                                <label className="flex-opt">
                                    <img className="country-sm pc-country4" src={Ng} alt=""/>
                                    <span className="opt-number">
                                    +234
                                </span>
                                </label>
                            </div>

                        <div className="pc-option4" 
                        //onClick={this.handleChoice}
                        >
                            <input type="radio" 
                            className="radio" 
                            id="country"
                            name="country"
                            value="+233"
                            />
                            <label className="flex-opt">
                                <img src={Gh} alt="" className="country-sm pc-country4"/>
                                <span className="opt-number">+233</span>
                            </label>
                        </div>
                    </div>

                    <div className="pc-selected4">
                        <div className="flex-opt">
                            <img src={Ng} alt="" className="country-sm pc-country4"/>
                            {/* <span className="opt-number right-mc">NG </span> */}
                            <span className="opt-number right-m3">+234</span>
                            <img src={Arrow} alt="" className="country-sm2 pc-arrow4"/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

